module.exports = __webpack_public_path__ + "img/cover_02.3a6f53fe.png";